import { isTestUserEmail } from './index';

export interface SessionCookieGenerator {
  generateCookie(params: {
    user: {
      email: string;
      sub: string;
    };
    tokenSet: {
      accessToken: string;
      expiresAt: number;
    };
    secret: string;
  }): Promise<string>;
}

export interface TestAuthConfig {
  email: string;
  fromHeaderToken: string;
  auth0Secret: string;
  fetchTokenSet: (
    email: string,
    fromHeaderToken: string,
  ) => Promise<{
    access_token: string;
    id_token: string;
    expires_in: number;
  }>;
  sessionCookieGenerator: SessionCookieGenerator;
}

export interface TestAuthResult {
  sessionCookie: string;
  expiresAt: number;
}

export async function createTestAuthSession(config: TestAuthConfig): Promise<TestAuthResult> {
  const { email, fromHeaderToken, auth0Secret, fetchTokenSet, sessionCookieGenerator } = config;

  if (!email || !isTestUserEmail(email)) {
    throw new Error('Invalid email');
  }

  const tokenSet = await fetchTokenSet(email, fromHeaderToken);
  const expiresAt = Math.floor(Date.now() / 1000) + tokenSet.expires_in;

  const sessionCookie = await sessionCookieGenerator.generateCookie({
    user: {
      email,
      sub: email,
    },
    tokenSet: {
      accessToken: tokenSet.access_token,
      expiresAt,
    },
    secret: auth0Secret,
  });

  return {
    sessionCookie,
    expiresAt,
  };
}
